import { getBaseUrl } from '@pique/graphql';

export function popupWindow(target: string) {
  const isExternal = /^https?:\/\//.test(target);

  if (!isExternal) {
    const base = getBaseUrl() || runtimeConfig.serverUrlPrefix;
    target = base + target;
  }

  if (environment.isTauri) {
    import('@tauri-apps/plugin-opener').then(({ openUrl }) => {
      openUrl(target);
    });
    return null;
  }

  return window.open(target, '_blank', 'noreferrer noopener');
}
